import Box from '@mui/material/Box';
import { useIsMobile } from '@repo/mui-config/hooks';
import { ModalHeader, Modal } from '@repo/ui';

import type { ModalProps } from '../display-modal';
import { ModalContent } from '../modal-content';

export function ModalPragmaForm({ modalState, isModalOpen, closeModal }: ModalProps) {
  const isMobile = useIsMobile();

  return (
    <Modal isOpen={isModalOpen} maxWidth="lg">
      <Box sx={{ py: 4, px: isMobile ? '20px' : '44px' }}>
        <ModalHeader
          centeredLogo={false}
          closeButton={{ isVisible: true, onClick: closeModal }}
          sx={{ mb: '20px' }}
        />
        <ModalContent modalType={modalState} />
      </Box>
    </Modal>
  );
}
